export const mapsKey = "AIzaSyDJkUXOPoxG2pIcf9X7xkfsiIyYYFUIZWU";
